import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

const PHONE_DISPLAY = "+91 90911 00200";
const PHONE_TEL = "+919091100200";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative gradient-navy text-white pt-16 pb-10">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{
        backgroundImage: "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
        backgroundSize: "24px 24px",
      }} />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="bg-white inline-block rounded-2xl p-3 mb-5 soft-shadow">
              <img src="/travel-factor-logo.png" alt="Travel Factor" className="h-14 w-auto object-contain" />
            </div>
            <p className="text-sm text-white/75 max-w-md leading-relaxed mb-6">
              A premium international travel & US visa consultancy crafting cinematic journeys and approved passports since 2014.
            </p>
            <div className="space-y-3">
              <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="flex items-center gap-3 text-sm text-white/90 hover:text-gold transition-colors">
                <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                  <Phone className="w-4 h-4 text-gold" strokeWidth={2.2} />
                </div>
                <span className="font-medium">{PHONE_DISPLAY}</span>
              </a>
              <a href="mailto:travelfator01@gmail.com" data-testid="footer-email" className="flex items-center gap-3 text-sm text-white/90 hover:text-gold transition-colors">
                <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-gold" strokeWidth={2.2} />
                </div>
                <span className="font-medium break-all">travelfator01@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-white/90" data-testid="footer-address">
                <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center shrink-0 mt-0.5">
                  <MapPin className="w-4 h-4 text-gold" strokeWidth={2.2} />
                </div>
                <span className="font-medium leading-relaxed">
                  Shop No. 09, 2nd Floor, Raghuleela Mall,<br/>
                  Jai Bhim Sanjay Nagar, Kandivali West,<br/>
                  Mumbai, Maharashtra 400067
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <FooterCol title="Services" items={["US Tourist Visa", "Student Visa", "Business Visa", "Documentation", "Interview Prep"]} />
          </div>
          <div className="md:col-span-2">
            <FooterCol title="Company" items={["About Us", "Press", "Careers", "Privacy", "Terms"]} />
          </div>
          <div className="md:col-span-2">
            <FooterCol title="Destinations" items={["Switzerland", "Dubai", "USA", "Singapore", "Bali", "Maldives"]} />
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/60">© {new Date().getFullYear()} Travel Factor. All rights reserved.</p>
          <p className="text-[10px] uppercase tracking-[0.28em] text-white/50">Mumbai · Delhi · Bengaluru</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.28em] text-gold font-bold mb-4">{title}</div>
      <ul className="space-y-2.5">
        {items.map((i) => (
          <li key={i}>
            <a href="#" className="text-sm text-white/80 hover:text-white transition-colors">
              {i}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
